// extracted by mini-css-extract-plugin
export default {"customOptionContainer":"SelectCustomOption_customOptionContainer__J0bxx"};